module.exports = __webpack_public_path__ + "img/worship-service.d0969a42.jpeg";